module.exports = __webpack_public_path__ + "static/media/23-10.ff9fd678.mp3";